import { Component, Input } from '@angular/core'
import { SystemInfoModel } from '../../../../../models/system-info.model'

@Component({
    selector: 'app-plant-name',
    templateUrl: './plant-name.component.html',
    styleUrls: ['./plant-name.component.scss'],
    standalone: false
})
export class PlantNameComponent {
  @Input() systemInfo: SystemInfoModel

  constructor() {}
}
